import React from 'react';
import './VerifyEmail.css'; // Arquivo CSS para os estilos
import logo from './logo.png'; // Caminho para o logo
import googlePlayImage from './google.b20c07ec720bfa73a943.webp'; // Caminho para a imagem do Google Play
import { FaCheckCircle, FaCamera, FaClipboardList } from 'react-icons/fa'; // Importando ícones do FontAwesome

const VerifyEmail = () => {
  return (
    <div className="verify-email-container">
      <div className="verify-email-box">
        <img src={logo} alt="Carey Logo" className="verify-email-logo" />
        <h2 className="verify-email-title">Cadastro feito com Sucesso!</h2>
        <p className="verify-email-message">
          Estamos super felizes em tê-lo conosco nessa jornada! 😊
        </p>

        <h3 className="verify-email-subtitle">Baixe o APP:</h3>
        <a href="https://play.google.com/store/apps/details?id=com.carey.appy.CareyAppCuidadores" target="_blank" rel="noopener noreferrer">
          <img src={googlePlayImage} alt="Google Play Download" className="verify-email-google-play" />
        </a>

        <h3 className="verify-email-subtitle">Próximos Passos:</h3>
        <div className="verify-email-steps">
          <div className="step">
            <FaCheckCircle className="step-icon" />
            <p>1. Envie seus <strong>DOCUMENTOS</strong> para verificar sua conta.</p>
          </div>
          <div className="step">
            <FaCamera className="step-icon" />
            <p>2. Complete seu perfil com uma <strong>FOTO</strong>, <strong>DESCRIÇÃO</strong>, e seus <strong>ATRIBUTOS</strong>. Quanto mais completo o seu perfil, mais chances!</p>
          </div>
          <div className="step">
            <FaClipboardList className="step-icon" />
            <p>3. Seja listado(a) <strong>GRATUITAMENTE</strong> para todas as vagas e famílias que procuram cuidadores!</p>
          </div>
        </div>

        <p className="verify-email-footer-text">
          Complete essas etapas e comece a receber oportunidades! É tudo gratuito até a primeira mensagem. 😉
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;

